import { render, staticRenderFns } from "./BookPickingUpPage.vue?vue&type=template&id=13fc109b&scoped=true"
import script from "./BookPickingUpPage.vue?vue&type=script&lang=js"
export * from "./BookPickingUpPage.vue?vue&type=script&lang=js"
import style0 from "./BookPickingUpPage.vue?vue&type=style&index=0&id=13fc109b&prod&scoped=true&lang=scss"
import style1 from "./BookPickingUpPage.vue?vue&type=style&index=1&id=13fc109b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fc109b",
  null
  
)

export default component.exports